import dayjs from "dayjs";
import Moment from "moment";

export function format(formatType, value) {
  if (typeof value !== "undefined") {
    switch (formatType) {
      case "date":
        //before works
        // if (Moment(value).isAfter(Moment("01-01-0001")))
        //   return Moment(value).format("DD-MM-YYYY");
        // return "-";
        // new formater which handle 19's date
        if (Moment(value).isSame("0001-01-01T00:00:00")) {
          return "-";
        }
        return Moment(value).format("DD-MM-YYYY");
      case "dateTime":
        if (Moment(value).isAfter(Moment("01-01-0001")))
          return Moment(value).format("DD-MM-YYYY HH:mm");
        return "-";
      case "time":
        if (Moment(value).isAfter(Moment("01-01-0001")))
          return dayjs(value).format("HH:mm");
        return "-";
      case "number":
        return typeof value === "number"
          ? localStorage.getItem("lang") != "en"
            ? eurozone(value)
            : uszone.format(value)
          : typeof value !== "undefined"
          ? value
          : 0.0;
      default:
        return value;
    }
  } else return "-";
}

const eurozone = (number)=>
  {
        if(number){
    // Step 1: replace "." with a placeholder
let temp = number.toString().replace(/\./g, "#");

// Step 2: replace "," with "."
temp = temp.replace(/,/g, ".");

// Step 3: replace placeholder with ","
let result = temp.replace(/#/g, ",");
// Split integer and decimal parts
let [integerPart, decimalPart] = result.split(",");

// Add dot as thousands separator
integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

 if (!decimalPart) {
      decimalPart = "00";
    }
// Recombine with decimal part
return decimalPart ? `${integerPart},${decimalPart}` : integerPart;

    
  }
  };
const uszone = Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
